import React from 'react'
import Section from '../../../shared/settings/section'
import AccountDetailsForm from './account-details-form'
import ChangePasswordForm from './change-password-form'
import { TESTERS } from '../../../../lib/tester-classnames'

function AccountDetails() {
  return (
    <Section title="Account Details" testerClassName={TESTERS.ACCOUNT.DETAILS}>
      <AccountDetailsForm />
      <ChangePasswordForm />
    </Section>
  )
}

export default AccountDetails
